import { useTranslation } from 'react-i18next';

import { useSnackbarContext } from 'applications/GSP/pages/ParentHelper/providers/SnackbarProvider/hooks';
import { useMenu } from 'shared/components/Menu/hooks';
import { Snackbar } from 'shared/components/Snackbar';
import { DEFAULT_NOTIFICATION_DURATION } from 'shared/constants/notifications';
import { useMediaQuery } from 'shared/hooks/dom';

import { HistoryDesktop } from './components/HistoryDesktop';
import { HistoryMobile } from './components/HistoryMobile';
import { SnackbarActionsButton } from './components/SnackbarActionsButton';
import { Provider as MenuProvider } from './context';
import { useDeleteChat } from './hooks';

export const History = () => {
  const { t } = useTranslation();
  const menu = useMenu();
  const matches = useMediaQuery('lg');
  const { isDeletingOpened } = useSnackbarContext();
  const onDeleteChat = useDeleteChat();

  return (
    <MenuProvider value={menu}>
      {matches ? <HistoryDesktop /> : <HistoryMobile />}
      <Snackbar
        open={isDeletingOpened}
        onClose={onDeleteChat}
        message={t('GSP.pages.parentHelper.history.deleteSnackbar.message')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        action={<SnackbarActionsButton />}
        autoHideDuration={DEFAULT_NOTIFICATION_DURATION}
      />
    </MenuProvider>
  );
};
